webpackJsonp([1],{

/***/ "+p9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ "/5AO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/N8/":
/***/ (function(module, exports) {

module.exports = [{
  title: 'Ремонт ходовой',
  info: 'Современные автомобили обладают большим количеством электроники, которая следит за каждым узлом автомобиля. Вся эта информация обрабатывается блоком управления. Какие то основные ошибки в работе авто можно увидеть на приборной панели. При поступлении автомобиля на наш сервис одним из обязательных условий ремонта является компьютерная диагностика. Она позволяет более точно судить о неисправности того или иного узла автомобиля.',
  items: [{
    title: 'Компьютерная диагностика Bosch',
    info: 'Во многих автомобилях установлена топливная техника Bosch. Это один из лидеров по производству топливной аппаратуры для дизельных двигателей. Наш сервис предоставляет компьютерную диагностику такой техники с помощью Bosch KTS. Это позволяет детально изучить такие параметры:',
    list: ['считывание/стирание кодов неисправностей', 'вывод текущих параметры системы в цифровом/графическом виде', 'активирует специальные режимы работы контроллера', 'описывает расположение диагностических колодок', 'сбрасывает сервисные счетчики', 'контролирует уровень масла', 'разблокирует иммобилайзер', 'проверка ESP', 'другие функции (чтение VIN, статический тест и т.д.)']
  }, {
    title: 'Компьютерная диагностика Delphi',
    info: 'Также одним из лидеров топливной дизельной аппаратуры является Delphi. Для этого оборудования в нашем сервисе имеется официальная диагностика Delphi. Кроме всего прочего диагностический прибор Delphi позволяет проводить диагностику:',
    list: ['двигателя по заводским протоколам', 'систем управления климатом', 'иммобилайзеров', 'систем управления трансмиссией', 'систем ABS', 'систем SRS Airbag', 'систем обеспечения комфорта', 'систем кузовной электроникиа']
  }, {
    title: 'Компьютерная диагностика OEM',
    info: 'Кроме таких мульти-сканеров которые предлагает Bosch и Delphi, в нашем распоряжении есть оригинальная диагностика от производителей авто. Она позволяет провести полную диагностику авто конкретной марки. В отдельных случаях позволяет считать те параметры, которые не могут считать мульти-марочные сканеры.',
    list: ['компьютерная диагностика Mercedes-Benz', 'компьютерная диагностика VW', 'компьютерная диагностика Volvo', 'компьютерная диагностика Scania', 'OEM компьютерная диагностика двигателей Cummins, Detroit Diesel, Caterpillar']
  }, {
    title: 'Выездная диагностика',
    info: 'Возможна выездная диагностика. Должны заметить, что диагностика это лишь часть ремонта, в которой определяется причина неисправности. В некоторых отдельных случаях не представляется возможным провести диагностику на месте. Иногда нужно провести частичную разборку, загнать машину на яму, провести диагностику дополнительным оборудованием (осцилографом, нанометром). В большинстве случаев мы советуем Вам транспортировать технику в наш сервис и на месте решать проблему.'
  }]
}];

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0JBb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Top',{attrs:{"windowWidth":_vm.windowWidth}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"windowWidth":_vm.windowWidth}})],1),_vm._v(" "),_c('Bottom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0KfL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0iGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Maps__ = __webpack_require__("D/+o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_phone__ = __webpack_require__("73Iz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_times__ = __webpack_require__("1UlI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_square__ = __webpack_require__("2PPF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_js_get_meta__ = __webpack_require__("hIjL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Maps: __WEBPACK_IMPORTED_MODULE_0__common_Maps__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__common_js_get_meta__["a" /* default */]],
  props: ['windowWidth'],
  data: function data() {
    return {
      title: 'Контакты',
      content: 'Телефоны, адрес СТО Автодизель',
      showAllPhones: true,
      showPhoneToggle: true,
      phones: [{
        destination: 'Стол заказов',
        number: '+7 856 387 44 61'
      }, {
        destination: 'Стол заказов MTC',
        number: '099 070 50 42'
      }, {
        destination: 'Стол заказов Феникс',
        number: '+7 949 346 69 40'
      }]
    };
  },

  watch: {
    windowWidth: function windowWidth(val) {
      if (val > 639) {
        this.showAllPhones = true;
        this.showPhoneToggle = false;
      } else {
        this.showAllPhones = false;
        this.showPhoneToggle = true;
      }
    }
  }
});

/***/ }),

/***/ "1B3p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPhoneToggle),expression:"showPhoneToggle"}],staticClass:"icon-for-phones",attrs:{"for":"toggle-phones"}},[_c('icon',[_c('icon',{staticClass:"phone",attrs:{"name":_vm.showAllPhones ? 'times' : 'phone',"scale":"2"}})],1)],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showAllPhones),expression:"showAllPhones"}],attrs:{"type":"checkbox","id":"toggle-phones"},domProps:{"checked":Array.isArray(_vm.showAllPhones)?_vm._i(_vm.showAllPhones,null)>-1:(_vm.showAllPhones)},on:{"__c":function($event){var $$a=_vm.showAllPhones,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showAllPhones=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showAllPhones=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showAllPhones=$$c}}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAllPhones),expression:"showAllPhones"}],staticClass:"contact-info"},[_c('table',[_c('tbody',_vm._l((_vm.phones),function(phone,key){return _c('tr',{key:key},[_c('td',[_c('span',{staticClass:"destination"},[_vm._v(_vm._s(phone.destination))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"phone"},[_vm._v(_vm._s(phone.number))])])])}))])])]),_vm._v(" "),_c('Maps')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1lyH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css__ = __webpack_require__("mytj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js__ = __webpack_require__("JHUq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__js__);



/***/ }),

/***/ "2S3x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "42Hy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("DK6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69c1a88a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("uwYz");
function injectStyle (ssrContext) {
  __webpack_require__("shqi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69c1a88a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69c1a88a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4OWD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.app__loader},[_c('img',{class:_vm.$style.loader__spinner,attrs:{"src":"/static/loader__spinner.svg"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4soe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5NYI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7+Kn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container service"},[_c('div',{staticClass:"row"},[_c('h1',[_vm._v(_vm._s(_vm.service.title))])]),_vm._v(" "),_c('div',{staticClass:"row row-centered"},[_vm._l((_vm.service.items),function(item,key){return _c('div',{key:key,staticClass:"col-sm-3 col-md-3 col-centered"},[_c('ServiceItem',{attrs:{"item":item}})],1)}),_vm._v(" "),_c('p',{staticClass:"about"},[_vm._v(_vm._s(_vm.service.info))])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Oz0":
/***/ (function(module, exports) {

module.exports = [{
  title: 'Ремонт дизельных двигателей',
  info: 'Дизельные двигатели в большинстве случаев весьма надежны и долговечны. Особенно если проходить ТО своевременно. Важно использовать качественное топливо, вовремя менять расходники.  Современные дизеля становятся все сложнее обрастая электроникой, различными навесными системами для обеспечения безотказной работы в разных условиях работы.',
  items: [{
    title: 'Капитальный ремонт ДВС',
    info: 'Капитальный ремонт дизельного двигателя одна из самых трудоемких операций по ремонту дизельных авто. Если по результатам диагностики выявлена неисправность в ДВС, двигатель нужно будет:',
    list: ['демонтировать дизельный двигатель', 'отмыть детали', 'произвести дефектовку, осмотр коленвала, параметры зазоров,трещины', 'ремонт головки блока цилиндров, блока цилиндров, ремонт коленвала']
  }, {
    title: 'Замена навесных узлов и агрегатов',
    info: 'Дизельные двигатели могут быть оборудованы дополнительными устройствами. Наш сервис предоставляют услуги по замене и ремонту некоторых из них. Просим обратить внимание, что некоторые такие устройства не поддаются ремонту. К услугам по ремонту навесным узлам и агрегатам дизельного двигателя относятся:',
    list: ['Ремонт, замена турбины(турбонаддув)', 'впускной/выпускной коллекторы', 'клапан EGR', 'помпа']
  }]
}];

/***/ }),

/***/ "7oBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__("m0SV");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ "96kx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.clazz,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path){return _c('path',_vm._b({},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon){return _c('polygon',_vm._b({},'polygon',polygon,false))}):_vm._e(),_vm._v("\b\n    "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.icon.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9aqz":
/***/ (function(module, exports) {

module.exports = [{
  title: 'Компьютерная диагностика',
  info: 'Ремонт автомобиля должен начинаться с компьютерной диагностики. Она позволяет с большой долей точности определить несиправность.',
  items: [{
    title: 'Компьютерная диагностика Bosch',
    info: 'Во многих автомобилях установлена топливная техника Bosch. Это один из лидеров по производству топливной аппаратуры для дизельных двигателей. Наш сервис предоставляет компьютерную диагностику такой техники с помощью Bosch KTS. Это позволяет детально изучить такие параметры:',
    list: ['считывание/стирание кодов неисправностей', 'вывод текущих параметры системы в цифровом/графическом виде', 'активирует специальные режимы работы контроллера', 'описывает расположение диагностических колодок', 'сбрасывает сервисные счетчики', 'контролирует уровень масла', 'разблокирует иммобилайзер', 'проверка ESP', 'другие функции (чтение VIN, статический тест и т.д.)']
  }, {
    title: 'Компьютерная диагностика Delphi',
    info: 'Также одним из лидеров топливной дизельной аппаратуры является Delphi. Для этого оборудования в нашем сервисе имеется официальная диагностика Delphi. Кроме всего прочего диагностический прибор Delphi позволяет проводить диагностику:',
    list: ['двигателя по заводским протоколам', 'систем управления климатом', 'иммобилайзеров', 'систем управления трансмиссией', 'систем ABS', 'систем SRS Airbag', 'систем обеспечения комфорта', 'систем кузовной электроникиа']
  }, {
    title: 'Компьютерная диагностика OEM',
    info: 'Кроме таких мульти-сканеров которые предлагает Bosch и Delphi, в нашем распоряжении есть оригинальная диагностика от производителей авто. Она позволяет провести полную диагностику авто конкретной марки. В отдельных случаях позволяет считать те параметры, которые не могут считать мульти-марочные сканеры.',
    list: ['компьютерная диагностика Mercedes-Benz', 'компьютерная диагностика VW', 'компьютерная диагностика Volvo', 'компьютерная диагностика Scania', 'OEM компьютерная диагностика двигателей Cummins, Detroit Diesel, Caterpillar']
  }, {
    title: 'Выездная диагностика',
    info: 'Возможна выездная диагностика. Должны заметить, что диагностика это лишь часть ремонта, в которой определяется причина неисправности. В некоторых отдельных случаях не представляется возможным провести диагностику на месте. Иногда нужно провести частичную разборку, загнать машину на яму, провести диагностику дополнительным оборудованием (осцилографом, нанометром). В большинстве случаев мы советуем Вам транспортировать технику в наш сервис и на месте решать проблему.'
  }]
}];

/***/ }),

/***/ "CltQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.pageBgStyles),attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.content))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.images),function(item,key){return _c('div',{key:key,staticClass:"col-xs-4 col-sm-3 col-centered"},[_c('img',{staticClass:"responsive-image",attrs:{"src":item.src}})])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D/+o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Maps_vue__ = __webpack_require__("gyLp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18687a24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Maps_vue__ = __webpack_require__("ML9R");
function injectStyle (ssrContext) {
  __webpack_require__("aTlg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18687a24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Maps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18687a24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Maps_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4d413a9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("96kx");
function injectStyle (ssrContext) {
  __webpack_require__("dWBd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4d413a9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DK6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_check_square_o__ = __webpack_require__("O+1C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_building__ = __webpack_require__("cWpK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_wrench__ = __webpack_require__("jyUL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_js_page_bg_styles__ = __webpack_require__("a/Q/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_js_get_meta__ = __webpack_require__("hIjL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__common_js_page_bg_styles__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__common_js_get_meta__["a" /* default */]],
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */],
    swiper: __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      // pageBgStyles: '',
      title: 'Ремонт дизельной топливной аппаратуры',
      image: '/static/index.jpg',
      content: 'Основное направление нашего сервиса - ремонт топливных дизельных систем. ',
      list: {
        main: ['На рынке автосервисных услуг уже более 15 лет', 'Обслуживаем более 700 предприятий региона', 'Ремонт ТНВД, форсунок, насос-форсунок, Common Rail', 'Ремонт дизельных двигателей'],
        other: [{
          title: 'Авторизованный сервисный центр Delphi',
          image: '/static/manufactures/delphi.png'
        }, {
          title: 'Официальный представитель Cummins',
          image: '/static/manufactures/cummins.png'
        }, {
          title: 'Установка фильтров сепараторов Stanadyne',
          image: '/static/manufactures/stanadyne.png'
        }, {
          title: 'Установка фильтров Fleetguard',
          image: '/static/manufactures/fleetguard.png'
        }, {
          title: 'Ремонт топливной аппаратуры Bosch',
          image: '/static/manufactures/bosch.png'
        }, {
          title: 'Ремонт топливной аппаратуры Delphi',
          image: '/static/manufactures/delphi.png'
        }, {
          title: 'Ремонт топливной аппаратуры Detroit Diesel',
          image: '/static/manufactures/detroit.png'
        }, {
          title: 'Ремонт топливной аппаратуры Siemens',
          image: '/static/manufactures/siemens.png'
        }]
      },
      swiperOption: {
        slidesPerView: 5,
        autoplay: 3000,
        spaceBetween: 0,
        loop: true,
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 0
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 0
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 0
          }
        }
      }
    };
  },

  methods: {
    getIcon: function getIcon(key) {
      switch (key) {
        case 0:
          return 'check-square-o';
        case 1:
          return 'building';
        default:
          return 'wrench';
      }
    }
  }
});

/***/ }),

/***/ "EHp9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-loader'
});

/***/ }),

/***/ "G7yb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GgDs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("JBW2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59a821da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("lXy/");
function injectStyle (ssrContext) {
  __webpack_require__("ymBb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59a821da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59a821da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H/+b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLoader_vue__ = __webpack_require__("EHp9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06511ed7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AppLoader_vue__ = __webpack_require__("4OWD");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("skZa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06511ed7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AppLoader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JBW2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_bars__ = __webpack_require__("inJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_times__ = __webpack_require__("1UlI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */]
  },
  props: ['windowWidth'],
  data: function data() {
    return {
      hamburger: false,
      showHeaderInfo: true,
      phones: [{ num: '099 070 50 42' }, { num: '+7 949 346 69 40' }],
      location: 'г.Донецк ул. Ленинградская, 1',
      topNavs: [{
        url: '/',
        title: 'Компания'
      }, {
        url: '/achievments',
        title: 'Достижения'
      }, {
        url: '/equipments',
        title: 'Оборудование'
      }, {
        url: '/contacts',
        title: 'Контакты'
      }]
    };
  },

  watch: {
    windowWidth: function windowWidth(val) {
      if (val > 639) {
        this.hamburger = true;
        this.showHeaderInfo = false;
        if (val > 991) {
          this.showHeaderInfo = true;
        }
      } else {
        this.hamburger = false;
        this.showHeaderInfo = true;
      }
    }
  }
});

/***/ }),

/***/ "JHUq":
/***/ (function(module, exports) {



/***/ }),

/***/ "K3rX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K8Xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Achievments_vue__ = __webpack_require__("MgeI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dcd852c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Achievments_vue__ = __webpack_require__("CltQ");
function injectStyle (ssrContext) {
  __webpack_require__("xJ1l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0dcd852c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Achievments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dcd852c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Achievments_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LQEe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LWNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css_source_flippers_flipInX_css__ = __webpack_require__("2S3x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css_source_flippers_flipInX_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_animate_css_source_flippers_flipInX_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_wrench__ = __webpack_require__("jyUL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_times__ = __webpack_require__("1UlI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_circle__ = __webpack_require__("pYLg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['item'],
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */]
  },
  data: function data() {
    return {
      show: false
    };
  }
});

/***/ }),

/***/ "Ldef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ServiceItem__ = __webpack_require__("N32C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_get_meta__ = __webpack_require__("hIjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_wrench__ = __webpack_require__("jyUL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['service', 'windowWidth'],
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_js_get_meta__["a" /* default */]],
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */],
    ServiceItem: __WEBPACK_IMPORTED_MODULE_1__ServiceItem__["a" /* default */]
  },
  data: function data() {
    return {
      show: false
    };
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b31aaaf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("0JBb");
function injectStyle (ssrContext) {
  __webpack_require__("/5AO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b31aaaf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ML9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[(!_vm.mapReady)?_c('app-loader'):_vm._e(),_vm._v(" "),_c('yandex-map',{staticStyle:{"width":"100%","height":"100%"},attrs:{"coords":_vm.coords,"controls":['zoomControl'],"zoom":"16"}},[_c('ymap-marker',{attrs:{"marker-type":"placemark","coords":_vm.marker,"hint-content":"СТО АВТОДИЗЕЛЬ","balloon":{header: 'СТО АВТОДИЗЕЛЬ', body: 'Ленинградская 1 <br> 099 070 50 42 <br> +7 856  387 44 61 ', footer: 'Время работы с 9:00 - 17:00 по записи'},"icon":{color: 'red', glyph: 'theater'}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MPfG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Service_vue__ = __webpack_require__("Ldef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0819e044_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Service_vue__ = __webpack_require__("7+Kn");
function injectStyle (ssrContext) {
  __webpack_require__("5NYI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0819e044"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Service_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0819e044_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Service_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MgeI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_page_bg_styles__ = __webpack_require__("a/Q/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_get_meta__ = __webpack_require__("hIjL");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__common_js_page_bg_styles__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__common_js_get_meta__["a" /* default */]],
  data: function data() {
    return {
      src: '',
      title: 'Наши успехи и достижения',
      image: '/static/bg2.jpg',
      content: 'Специалисты нашего сервиса проходят обучение и сертификацию у официальных производителей топливного оборудования',
      galleryOptions: {},
      images: [{
        src: '/static/certificates/5.jpg',
        srcSmall: '/static/certificates/small/5.jpg',
        title: 'test'
      }, {
        src: '/static/certificates/small/8.jpg',
        title: 'test'
      }, {
        src: '/static/certificates/small/7.jpg',
        title: 'test'
      }, {
        src: '/static/certificates/small/9.jpg',
        title: 'test'
      }, {
        src: '/static/certificates/small/1.jpg',
        title: 'test'
      }, {
        src: '/static/certificates/small/2.jpg',
        title: 'test'
      }, {
        src: '/static/certificates/small/3.jpg',
        title: 'test'
      }, {
        src: '/static/certificates/small/6.jpg',
        title: 'test'
      }, {
        src: '/static/certificates/small/4.jpg',
        title: 'test'
      }]
    };
  }
});

/***/ }),

/***/ "N+zL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__("+p9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0a274684_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__("SuKt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0a274684_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "N32C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceItem_vue__ = __webpack_require__("LWNg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a391a91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceItem_vue__ = __webpack_require__("Q1h6");
function injectStyle (ssrContext) {
  __webpack_require__("kRPN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a391a91"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a391a91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__("1lyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_i18n__ = __webpack_require__("TXmL");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
/* eslint-disable no-new */

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }
});

/***/ }),

/***/ "PHoc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Equipments_vue__ = __webpack_require__("gXTL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a70273e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Equipments_vue__ = __webpack_require__("oomP");
function injectStyle (ssrContext) {
  __webpack_require__("VpDG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a70273e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Equipments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a70273e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Equipments_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q1h6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subservice"},[_c('div',{staticClass:"gradient",on:{"click":function($event){_vm.show = true}}},[_c('icon',{attrs:{"name":"wrench","scale":"2"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"title",on:{"click":function($event){_vm.show = true}}},[_vm._v(_vm._s(_vm.item.title)+" ")]),_vm._v(" "),_c('transition',{attrs:{"name":"flip","enter-active-class":"animated bounceInDown","leave-active-class":"animated bounceOutUp"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"mask"},[_c('div',{staticClass:"info container"},[_c('div',{staticClass:"row row-centered"},[_c('div',{staticClass:"close",on:{"click":function($event){_vm.show = false}}},[_c('icon',{attrs:{"name":"times","scale":"1"}})],1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.item.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.item.info))]),_vm._v(" "),(_vm.item.list)?_c('ul',_vm._l((_vm.item.list),function(info,key){return _c('li',{key:key},[_vm._v("\n              "+_vm._s(info)+"\n            ")])})):_vm._e()])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QYkA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkfL":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./comp": "9aqz",
	"./comp.js": "9aqz",
	"./electric": "tFiP",
	"./electric.js": "tFiP",
	"./electronic": "g0qW",
	"./electronic.js": "g0qW",
	"./engine": "7Oz0",
	"./engine.js": "7Oz0",
	"./hod": "/N8/",
	"./hod.js": "/N8/",
	"./services": "UMQS",
	"./services.js": "UMQS",
	"./spectechnic": "eVGA",
	"./spectechnic.js": "eVGA",
	"./to": "zIID",
	"./to.js": "zIID",
	"./topl": "XGI4",
	"./topl.js": "XGI4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QkfL";

/***/ }),

/***/ "Rooh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__ = __webpack_require__("0iGR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86604b0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__ = __webpack_require__("1B3p");
function injectStyle (ssrContext) {
  __webpack_require__("4soe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-86604b0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86604b0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RtzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container"},[_vm._t("parallax-bg"),_vm._v(" "),_c('div',{class:_vm.defaultSwiperClasses.wrapperClass},[_vm._t("default")],2),_vm._v(" "),_vm._t("pagination"),_vm._v(" "),_vm._t("button-prev"),_vm._v(" "),_vm._t("button-next"),_vm._v(" "),_vm._t("scrollbar")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SuKt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.slideClass},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UMQS":
/***/ (function(module, exports) {

module.exports = [{
  title: 'Ремонт дизельных двигателей',
  info: 'Дизельные двигатели в большинстве случаев весьма надежны и долговечны. Особенно если проходить ТО своевременно. Важно использовать качественное топливо, вовремя менять расходники.  Современные дизеля становятся все сложнее обрастая электроникой, различными навесными системами для обеспечения безотказной работы в разных условиях работы.',
  items: [{
    title: 'Капитальный ремонт ДВС',
    info: 'Капитальный ремонт дизельного двигателя одна из самых трудоемких операций по ремонту дизельных авто. Если по результатам диагностики выявлена неисправность в ДВС, двигатель нужно будет:',
    list: ['демонтировать дизельный двигатель', 'отмыть детали', 'произвести дефектовку, осмотр коленвала, параметры зазоров,трещины', 'ремонт головки блока цилиндров, блока цилиндров, ремонт коленвала']
  }, {
    title: 'Замена навесных узлов и агрегатов',
    info: 'Дизельные двигатели могут быть оборудованы дополнительными устройствами. Наш сервис предоставляют услуги по замене и ремонту некоторых из них. Просим обратить внимание, что некоторые такие устройства не поддаются ремонту. К услугам по ремонту навесным узлам и агрегатам дизельного двигателя относятся:',
    list: ['Ремонт, замена турбины(турбонаддув)', 'впускной/выпускной коллекторы', 'клапан EGR', 'помпа']
  }]
}, {
  title: 'Компьютерная диагностика',
  info: 'Современные автомобили обладают большим количеством электроники, которая следит за каждым узлом автомобиля. Вся эта информация обрабатывается блоком управления. Какие то основные ошибки в работе авто можно увидеть на приборной панели. При поступлении автомобиля на наш сервис одним из обязательных условий ремонта является компьютерная диагностика. Она позволяет более точно судить о неисправности того или иного узла автомобиля.',
  items: [{
    title: 'Компьютерная диагностика Bosch',
    info: 'Во многих автомобилях установлена топливная техника Bosch. Это один из лидеров по производству топливной аппаратуры для дизельных двигателей. Наш сервис предоставляет компьютерную диагностику такой техники с помощью Bosch KTS. Это позволяет детально изучить такие параметры:',
    list: ['считывание/стирание кодов неисправностей', 'вывод текущих параметры системы в цифровом/графическом виде', 'активирует специальные режимы работы контроллера', 'описывает расположение диагностических колодок', 'сбрасывает сервисные счетчики', 'контролирует уровень масла', 'разблокирует иммобилайзер', 'проверка ESP', 'другие функции (чтение VIN, статический тест и т.д.)']
  }, {
    title: 'Компьютерная диагностика Delphi',
    info: 'Также одним из лидеров топливной дизельной аппаратуры является Delphi. Для этого оборудования в нашем сервисе имеется официальная диагностика Delphi. Кроме всего прочего диагностический прибор Delphi позволяет проводить диагностику:',
    list: ['двигателя по заводским протоколам', 'систем управления климатом', 'иммобилайзеров', 'систем управления трансмиссией', 'систем ABS', 'систем SRS Airbag', 'систем обеспечения комфорта', 'систем кузовной электроникиа']
  }, {
    title: 'Компьютерная диагностика OEM',
    info: 'Кроме таких мульти-сканеров которые предлагает Bosch и Delphi, в нашем распоряжении есть оригинальная диагностика от производителей авто. Она позволяет провести полную диагностику авто конкретной марки. В отдельных случаях позволяет считать те параметры, которые не могут считать мульти-марочные сканеры.',
    list: ['компьютерная диагностика Mercedes-Benz', 'компьютерная диагностика VW', 'компьютерная диагностика Volvo', 'компьютерная диагностика Scania', 'OEM компьютерная диагностика двигателей Cummins, Detroit Diesel, Caterpillar']
  }, {
    title: 'Выездная диагностика',
    info: 'Возможна выездная диагностика. Должны заметить, что диагностика это лишь часть ремонта, в которой определяется причина неисправности. В некоторых отдельных случаях не представляется возможным провести диагностику на месте. Иногда нужно провести частичную разборку, загнать машину на яму, провести диагностику дополнительным оборудованием (осцилографом, нанометром). В большинстве случаев мы советуем Вам транспортировать технику в наш сервис и на месте решать проблему.'
  }]
}, {
  title: 'Ремонт электрики',
  info: 'Электрика в автомобиле это одна из важнейших частей которая требует ухода и качественного ремонта. Некачественные соединения проводки могут вызвать неисправность остальных узлов. Короткое замыкание может привести к непредвиденным результатам, от выхода из строя датчиков и блока управления до пожара. Мы вас предостерегаем, без должного уровня не стоит самому заниматься ремонтом электрической части автомобилей.',
  items: [{
    title: 'Ремонт генератора/стартера',
    info: 'Ремонт генератора происходит в несколько этапов:',
    list: ['демонтаж генератора/стартера', 'дефектовка генератора/стартера', 'непосредственно ремонт генератора/стартера', 'замена подшипников, замена щеток', 'монтаж генератора/стартера']
  }, {
    title: 'Общие работы по электрике',
    info: 'В общие работы по электрике входит:',
    list: ['ремонт/замена систем охлаждения, радиаторов', 'ремонт печи', 'ремонт проводки', 'ремонт блока предохранителей', 'ремонт/замена блока реле']
  }]
}, {
  title: 'Ремонт электроники',
  info: 'Современный автомобиль сложно себе представить без электроники. Эти устройства выполняют различную логику. Например следят уровнем масла, количеством топлива которое получает двигатель и т.д. Вся эта информация поступает в центральный блок управления, который хранит, анализирует, управляет большинством узлов автомобиля.',
  items: [{
    title: 'Удаление сажевого фильтра',
    info: 'Мы предлагаем отключение / деактивацию/ удаление сажевого фильтра (DPF/FAP). Одной из причин удаления сажевого фильтра может стать:',
    list: ['потеря мощности в нормальном режиме работы двигателя', 'увеличение расхода топлива', 'горит ошибка чек']
  }, {
    title: 'Удаление EGR',
    info: 'Система EGR (Система рециркуляции отработавших газов) предназначена для снижения образования оксидов азота, образуемых при работе двигателя. В некоторых случаях использование этой системы начинает негативно влиять на работу двигателя. Наш сервис предоставляет услугу по удалению клапана EGR. Мы предлагаем чистку, отключение EGR в Донецке:',
    list: ['програмное отключение клапана EGR', 'установка заглушки клапана EGR']
  }, {
    title: 'Ремонт/замена блока управления',
    info: 'Блоки управления (ECU) довольно надежны и ломаются редко. Причинами выхода из строя могут является: влага проникшая внутрь корпуса ECU, механические воздействия, неполадки в электропитании.',
    list: ['програмное отключение клапана EGR', 'установка заглушки клапана EGR']
  }]
}, {
  title: 'Ремонт дизельной топливной аппаратуры',
  info: 'Мы обслуживаем в Донецке ТНВД, насос-форсунки, форсунки, системы Common Rail уже 17 лет. В нашем распоряжении оборудование от официальных производителей систем Bosch, Hartridge, Delphi, Denso. Это позволяет делать высокоточные проверки и настройки.',
  items: [{
    title: 'Ремонт ТНВД и форсунок',
    info: 'Ремонт ТНВД и форсунок начинается с диагностики на стенде, осмотра под микроскопом степени износа. На стенде проверяются форсунки для оценки объема распыляемого топлива, проводится замер фактических параметров. Проводится сравнение с эталонными параметрами.В Донецке диагностируем , делаем регулировку и ремонт ТНВД и форсунок:',
    list: ['одноплунжерных насосов типа VE с механическими и электронными регуляторами производства BOSCH, ZEXEL, DENSO', 'ТНВД производства DELPHI (LUCAS) часто применяемых на легковых автомобилях, строительной и специализированной технике', 'рядных ТНВД  А, М, MW, P-типа с механическими и электронными регуляторами, Н-типа, производства BOSCH, ZEXEL, DENSO', 'ТНВД отечественной техники КамАЗ, ЯМЗ-236,ЯМЗ-238, ЯМЗ-240, МТЗ, СуперМАЗ ЕВРО-2, IKARUS', 'форсунок BOSCH,ZEXEL,DENSO однопружинных, двухступенчатых, форкамерных, непосредственного впрыска, а также форсунок отечественного производства']
  }, {
    title: 'Ремонт насос-форсунок',
    info: 'Насос-форсунка объединяет в себе и одноплунжерный насос и форсунку. За счет того, что за смазку трущихся деталей отвечает топливо, это становится одной из главных проблем выхода из строя насос-форсунки. Выполняем проверку, ремонт, замену насос-форсунок:',
    list: ['насос-форсунок легковых автомобилей VW, Skoda', 'насос-форсунок,PLD секций (насосных секций высокого давления) автомобилей МВ, VOLVO, SCANIA, DAF, IVECO', 'насос-форсунок, американского производства DETROIT DIESEL, CAT, Cummins']
  }, {
    title: 'Ремонт системы Common Rail',
    info: 'Можно считать что Common Rail это вершина эволюции топливной аппаратуры дизельных двигателей. В отличии от ТНВД конструкция упрощена,  топливо закачивается в одному рейку . С другой стороны за систему подачи топлива отвечают электронно управляемые форсунки. Так сама рейка оснащена большим количеством датчиков отвечающих за давление в рейке, систем аварийного сброса давления. Ремонт таких систем требует спец оборудования, а также должной квалификации.В Донецке выполняем диагностику,ремонт систем Common Rail, форсунок:',
    list: ['Delphi на оборудовании фирмы HARTRIDGE дополнительно оснащенном дилерским программным обеспечением DELPHI которое позволяет при успешном прохождении теста присваивать форсунке индивидуальный код, который при монтаже прописывается в блок управления двигателя с привязкой к номеру цилиндра на который устанавливается форсунка.', 'BOSCH широко применяющихся как на легковых так и на грузовых автомобилях и спецтехнике Европейского, Азиатского,  Японского производства.  Ремонт производится с соблюдение технологии ремонта и регулировочных параметров фирмы BOSCH', 'DENSO устанавливаемых на автомобилях TOYOTA, NISSAN, FORD, CITROEN, PEUGEOT, MAZDA,SUBARU, OPEL, ISUZU, а также сельскохозяйственной и специализированной технике JOHN DEERE, JCB, HITACHI, KOMATSU']
  }]
}, {
  title: 'ТО дизельной техники',
  info: 'Наш сервис предлагает обслуживание вашего авто на регулярной основе. Меняйте фильтра, масло своевременно. Ведь это продлит срок службы вашего авто. После прохождения ТО делаем обнуление сервиса.',
  items: [{
    title: 'Замена фильтров',
    info: 'Заблаговременно меняя фильтры вы оберегаете себя от дорогостоящего ремонта. Причины сменить топливный фильтр:',
    list: ['увеличился расход топлива', 'уменьшилась мощность двигателя', 'двигатель начинает троить', 'двигатель глохнет на холостом ходу', 'при повышении оборотов в работе двигателя происходят провалы']
  }, {
    title: 'Замена масла',
    info: 'Наличие масла на всех узлах гарантирует отсутствие трения и преждевременного износа деталей вашего автомобиля. Не упустите того момента когда масло закончится, ведь масло:',
    list: ['защищает двигатель от износа', 'защищает детали от перегрева', 'защищает поверхность металла от коррозии', 'выводит твердые продукты сгорания топливно-воздушной смеси (нагар, сажа и др.)', 'выводит продукты износа двигателя (металлическая стружка)']
  }, {
    title: 'Замена свечей накала',
    info: 'Меняем вышедшие из строя свечи накаливания. Симптомы нестабильной работы свечей накала на дизельном автомобиле:',
    list: ['затрудненный запуск двигателя', 'наличие белого дыма из выхлопной трубы']
  }]
}, {
  title: 'Ремонт дизельной грузовой и спецтехники',
  info: 'Современные грузовые траки и спецтехника почти на 90 процентов приводится в движение с помощью дизельных двигателей. Автосервис Автодизель выполнит диагностику, ремонт грузовых траков, погрузчиков, тракторов, сельхоз техники.',
  items: [{
    title: 'Ремонт грузовой дизельной техники',
    info: 'Отремонтируем грузовые автомобили:',
    list: [' RENAULT (РЕНО), VOLVO (ВОЛЬВО)-(Америка), MERCEDES-BENZ TRUCK (Мерседес-Бенц трак), SCANIA (СКАНИЯ), DAF (ДАФ), MAN (МАН), IVECO (ИВЕКО), Hino (ХИНО), ShacMan (Шакман), HYUNDAI (Хундай), MACK (МАК), MITSUBISHI (МИТСУБИСИ), NISSAN (НИССАН), ISUZU (ИСУЗУ), VOLVO (ВОЛЬВО), FREIGHTLINER (Фредлайнер), CATERPILLAR (Катерпиллер), FORD (ФОРД), INTERNATIONAL (Интернационал), JCB (ДжиСиБи), FOTON (Фотон), FAW (ФАВ), HOWO (ХОВО), Dongfeng (Донг Фенг), Shaanxi (Шанк Си), BAW (БАВ), КАМАЗ, ГАЗ, ЗИЛ']
  }, {
    title: 'Сельхоз и спецтехника',
    info: 'Ремонт дизельной сельхоз и спецтехники в Донецке',
    list: ['экскаваторов и погрузчиков VOLVO EW, EC, JCB, CASE, NEW HOLLAND, LIEBHERR, ATLAS, TEREX, KOMATSU, HITACHI', 'тракторов MEDION 310, FORD CARGO 3530, HUNTER, FENDT 936, CASE 310, MASSEY FERGUSON 8480, NEW HOLLAND T8050, JOHN DEERE 7820, 8336, 8420, 8850,9320, 9430, ROPA']
  }]
}];

/***/ }),

/***/ "Vi57":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"submenu"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"black-box"}),_vm._v(" "),_c('swiper',{attrs:{"options":_vm.swiperOption}},_vm._l((_vm.services),function(value,key){return _c('swiper-slide',{key:key},[_c('router-link',{attrs:{"to":value.url}},[_c('div',{staticClass:"caption"},[_vm._v(_vm._s(value.title))]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":value.img,"alt":""}})])])],1)})),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VpDG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wizd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.image,style:(_vm.pageBgStyles),attrs:{"id":"content"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.service.title)?_c('service',{attrs:{"service":_vm.service,"windowWidth":_vm.windowWidth}}):_c('div',{staticClass:"error"},[_vm._v("\n      Ошибка, данной услуги не существует\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XGI4":
/***/ (function(module, exports) {

module.exports = [{
  title: 'Ремонт дизельной топливной аппаратуры',
  info: 'Мы обслуживаем в Донецке ТНВД, насос-форсунки, форсунки, системы Common Rail уже 15 лет. В нашем распоряжении оборудование от официальных производителей систем Bosch, Hartridge, Delphi, Denso. Это позволяет делать высокоточные проверки и настройки.',
  items: [{
    title: 'Ремонт ТНВД и форсунок',
    info: 'Ремонт ТНВД и форсунок начинается с диагностики на стенде, осмотра под микроскопом степени износа. На стенде проверяются форсунки для оценки объема распыляемого топлива, проводится замер фактических параметров. Проводится сравнение с эталонными параметрами.В Донецке диагностируем , делаем регулировку и ремонт ТНВД и форсунок:',
    list: ['одноплунжерных насосов типа VE с механическими и электронными регуляторами производства BOSCH, ZEXEL, DENSO', 'ТНВД производства DELPHI (LUCAS) часто применяемых на легковых автомобилях, строительной и специализированной технике', 'рядных ТНВД  А, М, MW, P-типа с механическими и электронными регуляторами, Н-типа, производства BOSCH, ZEXEL, DENSO', 'ТНВД отечественной техники КамАЗ, ЯМЗ-236,ЯМЗ-238, ЯМЗ-240, МТЗ, СуперМАЗ ЕВРО-2, IKARUS', 'форсунок BOSCH,ZEXEL,DENSO однопружинных, двухступенчатых, форкамерных, непосредственного впрыска, а также форсунок отечественного производства']
  }, {
    title: 'Ремонт насос-форсунок',
    info: 'Насос-форсунка объединяет в себе и одноплунжерный насос и форсунку. За счет того, что за смазку трущихся деталей отвечает топливо, это становится одной из главных проблем выхода из строя насос-форсунки. Выполняем проверку, ремонт, замену насос-форсунок:',
    list: ['насос-форсунок легковых автомобилей VW, Skoda', 'насос-форсунок,PLD секций (насосных секций высокого давления) автомобилей МВ, VOLVO, SCANIA, DAF, IVECO', 'насос-форсунок, американского производства DETROIT DIESEL, CAT, Cummins']
  }, {
    title: 'Ремонт системы Common Rail',
    info: 'Можно считать что Common Rail это вершина эволюции топливной аппаратуры дизельных двигателей. В отличии от ТНВД конструкция упрощена,  топливо закачивается в одному рейку . С другой стороны за систему подачи топлива отвечают электронно управляемые форсунки. Так сама рейка оснащена большим количеством датчиков отвечающих за давление в рейке, систем аварийного сброса давления. Ремонт таких систем требует спец оборудования, а также должной квалификации.В Донецке выполняем диагностику,ремонт систем Common Rail, форсунок:',
    list: ['Delphi на оборудовании фирмы HARTRIDGE дополнительно оснащенном дилерским программным обеспечением DELPHI которое позволяет при успешном прохождении теста присваивать форсунке индивидуальный код, который при монтаже прописывается в блок управления двигателя с привязкой к номеру цилиндра на который устанавливается форсунка.', 'BOSCH широко применяющихся как на легковых так и на грузовых автомобилях и спецтехнике Европейского, Азиатского,  Японского производства.  Ремонт производится с соблюдение технологии ремонта и регулировочных параметров фирмы BOSCH', 'DENSO устанавливаемых на автомобилях TOYOTA, NISSAN, FORD, CITROEN, PEUGEOT, MAZDA,SUBARU, OPEL, ISUZU, а также сельскохозяйственной и специализированной технике JOHN DEERE, JCB, HITACHI, KOMATSU']
  }]
}];

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Index__ = __webpack_require__("42Hy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Achievments__ = __webpack_require__("K8Xc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Equipments__ = __webpack_require__("PHoc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Contacts__ = __webpack_require__("Rooh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ServiceWrapper__ = __webpack_require__("xA9J");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  pathToRegexpOptions: { strict: true },
  routes: [{
    path: '/',
    name: 'Index',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Index__["a" /* default */]
  }, {
    path: '/achievments',
    name: 'Achievments',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Achievments__["a" /* default */]
  }, {
    path: '/equipments',
    name: 'Equipments',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Equipments__["a" /* default */]
  }, {
    path: '/contacts',
    name: 'Contacts',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Contacts__["a" /* default */],
    props: true
  }, {
    path: '/service/:name',
    name: 'ServiceWrapper',
    component: __WEBPACK_IMPORTED_MODULE_6__components_ServiceWrapper__["a" /* default */],
    props: true
  }]
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "a/Q/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pageBgStyles: function pageBgStyles() {
      return {
        background: 'linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.4)), url("' + this.image + '")',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      };
    }
  }
});

/***/ }),

/***/ "aTlg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dWBd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),

/***/ "eVGA":
/***/ (function(module, exports) {

module.exports = [{
  title: 'Ремонт дизельной грузовой и спецтехники',
  info: 'Современные грузовые траки и спецтехника почти на 90 процентов приводится в движение с помощью дизельных двигателей. Автосервис Автодизель выполнит диагностику, ремонт грузовых траков, погрузчиков, тракторов, сельхоз техники.',
  items: [{
    title: 'Ремонт грузовой дизельной техники',
    info: 'Отремонтируем грузовые автомобили:',
    list: [' RENAULT (РЕНО), VOLVO (ВОЛЬВО)-(Америка), MERCEDES-BENZ TRUCK (Мерседес-Бенц трак), SCANIA (СКАНИЯ), DAF (ДАФ), MAN (МАН), IVECO (ИВЕКО), Hino (ХИНО), ShacMan (Шакман), HYUNDAI (Хундай), MACK (МАК), MITSUBISHI (МИТСУБИСИ), NISSAN (НИССАН), ISUZU (ИСУЗУ), VOLVO (ВОЛЬВО), FREIGHTLINER (Фредлайнер), CATERPILLAR (Катерпиллер), FORD (ФОРД), INTERNATIONAL (Интернационал), JCB (ДжиСиБи), FOTON (Фотон), FAW (ФАВ), HOWO (ХОВО), Dongfeng (Донг Фенг), Shaanxi (Шанк Си), BAW (БАВ), КАМАЗ, ГАЗ, ЗИЛ']
  }, {
    title: 'Сельхоз и спецтехника',
    info: 'Ремонт дизельной сельхоз и спецтехники в Донецке',
    list: ['экскаваторов и погрузчиков VOLVO EW, EC, JCB, CASE, NEW HOLLAND, LIEBHERR, ATLAS, TEREX, KOMATSU, HITACHI', 'тракторов MEDION 310, FORD CARGO 3530, HUNTER, FENDT 936, CASE 310, MASSEY FERGUSON 8480, NEW HOLLAND T8050, JOHN DEERE 7820, 8336, 8420, 8850,9320, 9430, ROPA']
  }]
}];

/***/ }),

/***/ "g0qW":
/***/ (function(module, exports) {

module.exports = [{
  title: 'Ремонт электроники',
  info: 'Современный автомобиль сложно себе представить без электроники. Эти устройства выполняют различную логику. Например следят уровнем масла, количеством топлива которое получает двигатель и т.д. Вся эта информация поступает в центральный блок управления, который хранит, анализирует, управляет большинством узлов автомобиля.',
  items: [{
    title: 'Удаление сажевого фильтра',
    info: 'Мы предлагаем отключение / деактивацию/ удаление сажевого фильтра (DPF/FAP). Одной из причин удаления сажевого фильтра может стать:',
    list: ['потеря мощности в нормальном режиме работы двигателя', 'увеличение расхода топлива', 'горит ошибка чек']
  }, {
    title: 'Удаление EGR',
    info: 'Система EGR (Система рециркуляции отработавших газов) предназначена для снижения образования оксидов азота, образуемых при работе двигателя. В некоторых случаях использование этой системы начинает негативно влиять на работу двигателя. Наш сервис предоставляет услугу по удалению клапана EGR. Мы предлагаем чистку, отключение EGR в Донецке:',
    list: ['програмное отключение клапана EGR', 'установка заглушки клапана EGR']
  }, {
    title: 'Ремонт/замена блока управления',
    info: 'Блоки управления (ECU) довольно надежны и ломаются редко. Причинами выхода из строя могут является: влага проникшая внутрь корпуса ECU, механические воздействия, неполадки в электропитании.',
    list: ['програмное отключение клапана EGR', 'установка заглушки клапана EGR']
  }]
}];

/***/ }),

/***/ "gXTL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_page_bg_styles__ = __webpack_require__("a/Q/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_get_meta__ = __webpack_require__("hIjL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__common_js_page_bg_styles__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__common_js_get_meta__["a" /* default */]],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      title: 'Проверка топливной аппаратуры на стенде',
      image: '/static/bg3.jpg',
      content: 'Наше оборудование позволяет придерживаться заводской технологии ремонта топливной аппаратуры(если такой возможен). Для большинства случаев проверки форсунок и насосов требуется специальные стенды. Они позволяют делать точные замеры параметров топливного дизельного оборудования.',
      equipments: [{
        title: 'Диагностический стенд AVM2-PC',
        text: 'Универсальный диагностический стенд AVM2-PC производства Hartridge — компании -лидера в области создания стендов для диагностики и испытаний дизельной топливной аппаратуры, используется для испытаний любых компонентов выпускаемых сегодня дизельных систем: рядных и роторных механических насосов, электронных насосов, насос-форсунок, насосов Common Rail и форсунок Common Rail. Наличие стенда - обязательное условие получения авторизации по ремонту насосов марок Delphi, Denso и VDO (Siemens).',
        img: '/static/equipments/avm2-pc.jpg'
      }, {
        title: 'Оборудование для испытаний насосов Common Rail HF1130',
        text: 'Комплект HF1130 используется для проверки и регулировки насосов Common Rail производства Bosch, Delphi, Denso и Siemens, обеспечивая уровень функциональных возможностей, до настоящего времени еще не достигнутый другими системами. Комплект работает совместно с испытательным стендом AVM2-PC (20л.с.) и базовым комплектом для Common Rail HB378.',
        img: '/static/equipments/hf1130.jpg'
      }, {
        title: 'Оборудование для испытаний EUI/EUP (электронных насос-форсунок и насосных секций)',
        text: 'Набор оснастки HK870 позволяет проводить на стенде AVM2-PC испытания электронных насос-форсунок и индивидуальных насосов с электронным управлением (EUI & EUP). Возможности и особенности : <ul><li>Точные и подробные результаты при испытаниях EUI/EUP</li><li> Испытания EUI соленоидного и пьезо типов.</li><li> Возможность авторизованного ремонта насос-форсунок Delphi серий А и Е1 при использовании тензометрического комплекта HB388.</li><li> Авторизованный ремонт насос-форсунок Delphi E3 </li><li> Применение сменных кулачков оригинального профиля позволяет точно воссоздать на стенде работу в реальных условиях, обеспечивая самую высокую точность результатов.</li></ul>',
        img: '/static/equipments/HB378_Medium.jpg'
      }, {
        title: 'Стенд для испытаний форсунок Common Rail',
        text: 'Специализированный стенд производства Hartridge CRi-PC предназначен для испытаний только форсунок систем Common Rail всех марок и типов. Сегодня это самый совершенный и производительный стенд своего рода, также может работать как в универсальном, так и в авторизованном Delphi режимах. В последнем случае, при работе с программным обеспечением Delphi Iris, стенд по результатам теста генерирует код c2i, а с недавнего времени c3i, необходимые для «прописки» форсунок Common Rail при установке на двигатель.',
        img: '/static/equipments/CRi_PC_Medium.jpg'
      }, {
        title: 'Диагностический стенд Testmaster-3',
        text: 'Testmaster 3 HH701 - это испытательный стенд для проверки работоспособности форсунок, оборудованный пневматическим приводом, совершенным и гибким програмным обеспечением и жидкокристаллическим дисплеем для отображения результатов. Testmaster 3 HH701 отличается компактными размерами, прост и гибок в эксплуатации, позволяет сохранять и выводить на печать результаты испытаний при помощи внешнего ПК/принтера.',
        img: '/static/equipments/HH701_Medium.jpg'
      }, {
        title: 'Стенд для диагностики двухпружинных форсунок 2-Stagemaster',
        text: '2 Stagemaster HH720 – экономически эффективный и простой в работе модуль для проверки двухступенчатых форсунок. HH720 используется совместно с приборами для испытания форсунок Testmaster-2 (HH700) или Testmaster-3 (HH701). 2 Stagemaster HH720 оборудован жидкокристаллическим экраном и простым автоматическим управлением для определения давления открытия второй ступени распылителя (NOP2).',
        img: '/static/equipments/HH700_Medium.jpg'
      }, {
        title: 'Приставка для диагностики насос-форсунок EUI Poptest',
        text: 'Модель HH705 сохраняет все функциональные возможности Testmaster-3, а также дополнительно позволяет тестировать насос-форсунки. Дополнительные функции могут быть обеспечены при работе с IFT-c и приставкой 2-Stagemaster- они позволят HH705 тестировать форсунки Common Rail и двухступенчатые форсунки.',
        img: '/static/equipments/hh705-300x243.jpg'
      }, {
        title: 'Прибор для диагностики Common Rail форсунок IFT-70',
        text: 'IFT-70 разработан для начальной диагностики форсунок Common Rail. IFT может быть использован либо как часть диагностики транспортного средства в мастерской  или как часть полной программы испытания, диагностики и ремонта форсунки при использовании в сочетании с испытательными стендами AVM или CRi-PC Hartridge. На сегодняшний день     IFT-70 представляет собой одно из лучших экономически эффективных решений для предварительной диагностики систем Common Rail',
        img: '/static/equipments/IFT70large.gif'
      }, {
        title: 'Системы для очистки',
        text: 'Для очистки механизмов и элементов топливной аппаратуры используется ультразвуковые ванны,Microdiesel-Cabinet «Чистый шкаф» ',
        img: '/static/equipments/microdiesel.jpg'
      }],
      swiperOption: {
        slidesPerView: 6,
        preloadImages: false,
        // Enable lazy loading
        lazyLoading: true,
        nextButton: '.equipments-next',
        prevButton: '.equipments-prev',
        spaceBetween: 2,
        breakpoints: {
          1024: {
            slidesPerView: 5,
            spaceBetween: 2
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 2
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 2
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 2
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 2
          }
        }
      }
    };
  }
});

/***/ }),

/***/ "gyLp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppLoader__ = __webpack_require__("H/+b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_yandex_maps__ = __webpack_require__("Hlu6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_yandex_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_yandex_maps__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { yandexMap: __WEBPACK_IMPORTED_MODULE_1_vue_yandex_maps__["yandexMap"], ymapMarker: __WEBPACK_IMPORTED_MODULE_1_vue_yandex_maps__["ymapMarker"], AppLoader: __WEBPACK_IMPORTED_MODULE_0__AppLoader__["a" /* default */] },
  data: function data() {
    return {
      mapReady: false,
      coords: [48.000187, 37.7665745],
      marker: [48.000587, 37.7665745]
    };
  },

  methods: {
    showMap: function showMap() {
      this.mapReady = true;
    }
  },
  created: function created() {
    setTimeout(this.showMap, 2000);
  }
});

/***/ }),

/***/ "hIjL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: function metaInfo() {
    return {
      title: this.getTitle(),
      titleTemplate: '%s | СТО Автодизель г.Донецк',
      meta: [{ name: 'description', content: this.getDescription() }]
    };
  },

  methods: {
    getTitle: function getTitle() {
      if (this.service) {
        return this.service.title;
      }
      return this.title;
    },
    getDescription: function getDescription() {
      if (this.service) {
        return this.service.info;
      }
      return this.content;
    }
  }
});

/***/ }),

/***/ "kRPN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lXy/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav"},[_c('label',{attrs:{"for":"toggle"}},[_c('icon',{attrs:{"name":_vm.hamburger ? 'times' : 'bars',"scale":"2"}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hamburger),expression:"hamburger"}],attrs:{"type":"checkbox","id":"toggle"},domProps:{"checked":Array.isArray(_vm.hamburger)?_vm._i(_vm.hamburger,null)>-1:(_vm.hamburger)},on:{"__c":function($event){var $$a=_vm.hamburger,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.hamburger=$$a.concat([$$v]))}else{$$i>-1&&(_vm.hamburger=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.hamburger=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"menu"},[_c('router-link',{attrs:{"to":_vm.topNavs[0]}},[_c('div',{staticClass:"logo"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHeaderInfo),expression:"showHeaderInfo"}],staticClass:"header-info"},[_c('div',{staticClass:"phones"},_vm._l((_vm.phones),function(phone,key){return _c('div',{key:key,staticClass:"phone-item"},[_c('i',{staticClass:"phone "}),_vm._v(_vm._s(phone.num)+"\n          ")])})),_vm._v(" "),_c('div',[_c('i',{staticClass:"location "}),_vm._v(_vm._s(_vm.location)+"\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hamburger || _vm.windowWidth> 639),expression:"hamburger || windowWidth> 639"}],staticClass:"navbar "},[_c('ul',_vm._l((_vm.topNavs),function(value,key){return _c('li',{key:key},[_c('router-link',{attrs:{"to":value.url},nativeOn:{"click":function($event){_vm.hamburger = !_vm.hamburger}}},[_vm._v(_vm._s(value.title))])],1)}))]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mytj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__ = __webpack_require__("v2ns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_grid_dist_grid_min_css__ = __webpack_require__("o26G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_grid_dist_grid_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_grid_dist_grid_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_animate_css_animate_min_css__ = __webpack_require__("0KfL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_animate_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_animate_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__normalize_css__ = __webpack_require__("G7yb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styl__ = __webpack_require__("QYkA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vars_styl__ = __webpack_require__("K3rX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vars_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__vars_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fonts_css__ = __webpack_require__("LQEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fonts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fonts_css__);








/***/ }),

/***/ "o26G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o5k9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oWBy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      services: [{
        title: 'Компьютерная диагностика',
        url: '/service/comp',
        img: '/static/services/comp.png'
      }, {
        title: 'Ремонт дизельных двигателей',
        url: '/service/engine',
        img: '/static/services/engine.png'
      }, {
        title: 'Ремонт топливной аппаратуры',
        url: '/service/topl',
        img: '/static/services/fors.png'
      }, {
        title: 'Ремонт электрики',
        url: '/service/electric',
        img: '/static/services/electro.png'
      }, {
        title: 'Ремонт электроники',
        url: '/service/electronic',
        img: '/static/services/electronic.png'
      }, {
        title: 'Ремонт ходовой',
        url: '/service/hod',
        img: '/static/services/hod.png'
      }, {
        title: 'Тех. обслуживание',
        url: '/service/to',
        img: '/static/services/oil.png'
      }, {
        title: 'Ремонт спецтехники',
        url: '/service/spectechnic',
        img: '/static/services/truck.png'
      }],
      swiperOption: {
        slidesPerView: 6,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 0,
        breakpoints: {
          1024: {
            slidesPerView: 5,
            spaceBetween: 0
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 0
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 0
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 0
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        }
      }
    };
  }
});

/***/ }),

/***/ "oomP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.pageBgStyles),attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('swiper',{attrs:{"options":_vm.swiperOption}},[_c('div',{staticClass:"equipments-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_vm._l((_vm.equipments),function(value,key){return _c('swiper-slide',{key:key},[_c('div',{staticClass:"img-wrap"},[_c('img',{staticClass:"swiper-lazy",attrs:{"src":value.img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"swiper-lazy-preloader swiper-lazy-preloader-white"}),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(value.title))])])})],2),_vm._v(" "),_c('div',{staticClass:"equipments-next",attrs:{"slot":"button-next"},slot:"button-next"})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pPC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_page_bg_styles__ = __webpack_require__("a/Q/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Service__ = __webpack_require__("MPfG");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__common_js_page_bg_styles__["a" /* default */]],
  data: function data() {
    return {};
  },

  props: ['name', 'windowWidth'],
  components: {
    Service: __WEBPACK_IMPORTED_MODULE_1__Service__["a" /* default */]
  },
  computed: {
    service: function service() {
      try {
        return __webpack_require__("QkfL")("./" + this.$route.params.name)[0];
      } catch (e) {
        return {};
      }
    },
    image: function image() {
      return '/static/services/bg/' + this.$route.params.name + '.jpg';
    }
  }
});

/***/ }),

/***/ "pYmz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("7oBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3ff850bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("RtzF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3ff850bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "shqi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "skZa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"app__loader":"jXVdiQCTPnM7SPtHc1K5G_0","loader__spinner":"_1fHPxmeqQIKQCFOJAzqn2U_0"};

/***/ }),

/***/ "tFiP":
/***/ (function(module, exports) {

module.exports = [{
  title: 'Ремонт электрики',
  info: 'Электрика в автомобиле это одна из важнейших частей которая требует ухода и качественного ремонта. Некачественные соединения проводки могут вызвать неисправность остальных узлов. Короткое замыкание может привести к непредвиденным результатам, от выхода из строя датчиков и блока управления до пожара. Мы вас предостерегаем, без должного уровня не стоит самому заниматься ремонтом электрической части автомобилей.',
  items: [{
    title: 'Ремонт генератора/стартера',
    info: 'Ремонт генератора происходит в несколько этапов:',
    list: ['демонтаж генератора/стартера', 'дефектовка генератора/стартера', 'непосредственно ремонт генератора/стартера', 'замена подшипников, замена щеток', 'монтаж генератора/стартера']
  }, {
    title: 'Общие работы по электрике',
    info: 'В общие работы по электрике входит:',
    list: ['ремонт/замена систем охлаждения, радиаторов', 'ремонт печи', 'ремонт проводки', 'ремонт блока предохранителей', 'ремонт/замена блока реле']
  }]
}];

/***/ }),

/***/ "uwYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.pageBgStyles),attrs:{"id":"content"}},[_c('div',{staticClass:"container "},[_c('div',{staticClass:"row info-other"},[_c('swiper',{attrs:{"options":_vm.swiperOption}},_vm._l((_vm.list.other),function(info,key){return _c('swiper-slide',{key:key},[_c('div',{staticClass:"info-other-item"},[_c('img',{attrs:{"src":info.image,"title":info.title,"alt":info.title}})])])}))],1),_vm._v(" "),_c('div',{staticClass:"top-info"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.content))])]),_vm._v(" "),_c('div',{staticClass:"row main-info row-centered"},_vm._l((_vm.list.main),function(info,key){return _c('div',{key:key,staticClass:"col-xs-12 col-sm-3 col-centered"},[_c('div',{staticClass:"main-info-item"},[_c('icon',{staticClass:"icon",attrs:{"name":_vm.getIcon(key),"scale":"2"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(info))])],1)])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xA9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceWrapper_vue__ = __webpack_require__("pPC+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d2a585_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceWrapper_vue__ = __webpack_require__("Wizd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d2a585_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceWrapper_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJ1l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Header__ = __webpack_require__("GgDs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Bottom__ = __webpack_require__("zJHf");
//
//
//
//
//
//
//
//
//
//



// import getMeta from './common/js/get-meta'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Top: __WEBPACK_IMPORTED_MODULE_0__components_common_Header__["a" /* default */],
    Bottom: __WEBPACK_IMPORTED_MODULE_1__components_common_Bottom__["a" /* default */]
  },
  // mixins: [getMeta],
  data: function data() {
    return {
      windowWidth: ''
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      this.getWindowWidth();
    });
  },

  methods: {
    getWindowWidth: function getWindowWidth(event) {
      this.windowWidth = document.documentElement.clientWidth;
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  }
});

/***/ }),

/***/ "ymBb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zIID":
/***/ (function(module, exports) {

module.exports = [{
  title: 'ТО дизельной техники',
  info: 'Наш сервис предлагает обслуживание вашего авто на регулярной основе. Меняйте фильтра, масло своевременно. Ведь это продлит срок службы вашего авто. После прохождения ТО делаем обнуление сервиса.',
  items: [{
    title: 'Замена фильтров',
    info: 'Заблаговременно меняя фильтры вы оберегаете себя от дорогостоящего ремонта. Причины сменить топливный фильтр:',
    list: ['увеличился расход топлива', 'уменьшилась мощность двигателя', 'двигатель начинает троить', 'двигатель глохнет на холостом ходу', 'при повышении оборотов в работе двигателя происходят провалы']
  }, {
    title: 'Замена масла',
    info: 'Наличие масла на всех узлах гарантирует отсутствие трения и преждевременного износа деталей вашего автомобиля. Не упустите того момента когда масло закончится, ведь масло:',
    list: ['защищает двигатель от износа', 'защищает детали от перегрева', 'защищает поверхность металла от коррозии', 'выводит твердые продукты сгорания топливно-воздушной смеси (нагар, сажа и др.)', 'выводит продукты износа двигателя (металлическая стружка)']
  }, {
    title: 'Замена свечей накала',
    info: 'Меняем вышедшие из строя свечи накаливания. Симптомы нестабильной работы свечей накала на дизельном автомобиле:',
    list: ['затрудненный запуск двигателя', 'наличие белого дыма из выхлопной трубы']
  }]
}];

/***/ }),

/***/ "zJHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bottom_vue__ = __webpack_require__("oWBy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7fda78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Bottom_vue__ = __webpack_require__("Vi57");
function injectStyle (ssrContext) {
  __webpack_require__("o5k9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f7fda78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bottom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7fda78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Bottom_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.aa6d8371314576e8839d.js